/**
 * Booking dates are calendar days, not instants: `transactions.booking_date` is a timestamp
 * column that only ever holds midnight, so the API sends them as `2024-03-01T00:00:00.000Z`.
 * Formatting those in the browser's timezone renders the *previous* day for anyone west of UTC,
 * which would make the rebuilt CSV and the date range disagree with the bank statement.
 *
 * These read the UTC calendar day instead, so the output is the same wherever it is viewed.
 */

/** UTC calendar day of `value` as `yyyy-MM-dd` — the CSV column format. */
export const toIsoBookingDay = (value: string): string =>
  new Date(value).toISOString().slice(0, 10);

/** UTC calendar day of `value` as `dd.MM.yyyy` — the format the tables use. */
export const formatBookingDay = (value: string | null): string => {
  if (!value) {
    return '—';
  }

  const [year, month, day] = toIsoBookingDay(value).split('-');

  return `${day}.${month}.${year}`;
};
